"use strict";
/* eslint-disable no-null/no-null */
Object.defineProperty(exports, "__esModule", { value: true });
exports.dbNull = exports.noRenderNull = void 0;
/**
 * Null intended to be only used in React components when we want
 * to indicate that the componet should not render.
 */
exports.noRenderNull = null;
/**
 * DB clients expect null values in many of their APIs.
 * To avoid writing a ESLint disable null rule everywhere,
 * we created a dbNull variable here that can be used by our
 * data-layer packages.
 */
exports.dbNull = null;
//# sourceMappingURL=null_types.js.map